export default "__VITE_ASSET__CefjlAOP__"